export enum TimelineColor {
  BLUE,
  GRAY,
  GREEN,
  RED,
}

export enum TimelineOverlayColor {
  BRAND_PRIMARY_LIGHT_00,
  WHITE,
}
export interface TimelineItemProps {
  dot?: React.ReactNode
  children: React.ReactNode
  className?: string
}

export interface TimelineProps {
  items: TimelineItemProps[]
  className?: string
  dotClassName?: string
  color?: TimelineColor
  overlayColor?: TimelineOverlayColor
  noDotTopSpacing?: boolean
}
